<template>
  <div class="info">
    <h1 class="info__title">Leadership</h1>

    <dots-number activeDots='5'/>

    <div class="info text-center">
      <div class="info__header">
        <img class="info__img" src="/static/img/Leadership.svg" alt="">
        <p class="info__header-text">
          Leaders are ‘connective leaders’ and act as catalysts and conductors, facilitating
          connections and creating a diverse environment where people can be inspired and authentic,
          and where change and people can flourish.
        </p>
      </div>
      <div class="info__footer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      id: 4,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Leadership/Info.vue